import React from 'react';
import useUrl from 'hooks/useUrl';

import ImgTag, { FmPriceStr, NameTag } from 'comps/ImgTag';

export default function ProductCard({ item }) {
  const { getPublicUrl } = useUrl()
  const {
    sysNo,
    salesPrice,
    name,
    imgPaths,
    productTagTitleList,
  } = item
  const href = `/product/detail?id=${sysNo}`
  return (
    <a
      className="product"
      rel="noreferrer"
      title={name}
      onClick={() => {
        window.open(href)
      }}
    >
      <div className="img-box">
        <ImgTag
          width={212}
          height={212}
          borderRadius={0}
          image={getPublicUrl(imgPaths?.[0])}
        />
      </div>
      <div className="info-box">
        <NameTag
          name={name}
          tag={productTagTitleList?.[0]?.tagName}
          lineHeight={21}
        />
        <FmPriceStr price={salesPrice} marginTop={10} />
      </div>
      <style jsx>{`
          .product {
            display: inline-block;
            vertical-align: top;
            width: 214px;
            margin-right: 12px;
            margin-bottom: 12px;
            padding-bottom: 3px;
            transtion: all 0.3s;
            border-radius: 8px;
            border: 1px solid #E9EFF4;
          }
          .product :global(.price) {
            color: #E4262F;
          }
          .product:nth-child(5n) {
            margin-right: 0px;
          }
          .product:hover :global(.name) {
            color: var(--primaryColor);
          }
          .product:hover {
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          }
          .img-box {
            width: 212px;
            height: 212px;
            background-color: #fff;
            transition: box-shadow 0.3s ease;
          }
          .info-box {
            padding: 15px;
          }
        `}</style>
    </a>
  )
}
